<template>
    <div>Schönherz</div>
</template>

<script lang="ts" setup>
</script>
